import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { mediaMinTablet } from '@root/shared/ui-kit'

import { CheckCurrency } from './check-currency'
import { CheckCurrencyFooter } from './check-currency-footer'
import { CheckCurrencyForm } from './check-currency-form'

import type {
  CheckCurrencyReatom,
  CurrencySafetyCheck,
} from '@root/features/premium/check-currency/atoms'

type Props = {
  result: CurrencySafetyCheck | undefined
  model: CheckCurrencyReatom
  withRetry?: boolean
}

export const CheckCurrencyFailed: React.FC<Props> = ({
  result,
  model,
  withRetry = true,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <CheckCurrency result={result} />
      {withRetry ? (
        <>
          <CheckCurrencyFooter>
            <Text>{t('premium.check.note.failed')}</Text>
          </CheckCurrencyFooter>
          <Margin>
            <CheckCurrencyForm model={model} mode="currency" />
          </Margin>
        </>
      ) : undefined}
    </>
  )
}

const Text = styled.p`
  margin-bottom: 16px;

  ${mediaMinTablet(css`
    margin: 18px 0 10px;

    font-style: normal;
    font-weight: 700;
    line-height: 140%;
  `)}
`

const Margin = styled.div`
  padding: 12px;
`
